import React from 'react';

import { IntlProvider } from 'react-intl';

import enMessages from '../../i18n/en';
import plMessages from '../../i18n/pl';

interface HeartbeatIntlProviderProps {
	children: React.ReactNode;
	locale?: string;
}

// Static message mapping for supported locales
const getMessagesForLocale = (locale: string): Record<string, string> => {
	switch (locale) {
		case 'pl':
			return plMessages;
		case 'en':
		default:
			return enMessages;
	}
};

export const HeartbeatIntlProvider = ({
	children,
	locale = 'en',
}: HeartbeatIntlProviderProps): JSX.Element => {
	const messages = getMessagesForLocale(locale);

	return (
		<IntlProvider locale={locale} messages={messages}>
			{children}
		</IntlProvider>
	);
};
